import {
  Entity,
  type EntityFields,
  type EntityRecord,
  Fields,
} from '@burnsred/entity';
import { default as DjangoRestFramework } from '@burnsred/entity-duck-namespace-drf';

import { duckAppName } from '@/constants';

class CategoryEntity extends Entity {
  static paginated = false;

  static paths = {
    apiBase: '/applications/v1/category/',
  };

  static fields: EntityFields<CategoryEntityFields> = {
    uuid: new Fields.IdField(),
    name: new Fields.CharField({ blank: true, local: true }),
  };

  static dataToRecord(data: Partial<CategoryEntityFields>) {
    return super.dataToRecord(data) as CategoryEntityRecord;
  }

  static toString(record: CategoryEntityRecord | null | undefined) {
    return record?.get('name') ?? '';
  }
}

export type CategoryEntityFields = {
  uuid: string;
  name: string;
};

export type CategoryEntityRecord = EntityRecord<CategoryEntityFields>;

CategoryEntity.duck = new DjangoRestFramework({
  app: duckAppName,
  entity: CategoryEntity,
  name: 'CategoryEntity',
});

export default CategoryEntity;
